// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 878) return "static/chunks/878-ddd63efa611b51f6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5223":"d5192df72e852dea","9272":"6adcf0c44f5df8ac","9724":"f6fc90006873d62d"}[chunkId] + ".js";
};